import { Text } from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CSVLink } from "react-csv";
import { generateLoanRows } from "utils/downloads";

export function DownloadLink({
	loans,
	columns,
}: {
	loans: any[];
	columns: any[];
}) {
	return loans.length > 0 ? (
		<CSVLink
			data={generateLoanRows(loans, columns)}
			filename={`loans_export_${new Date().getTime()}.csv`}
			style={{
				borderWidth: "1px",
				borderColor: "primary",
				color: "primary",
				paddingLeft: "1rem",
				paddingRight: "1rem",
				marginRight: "12px",
				borderRadius: "7px",
				display: "flex",
				alignItems: "center",
				verticalAlign: "middle",
				justifyContent: "center",
			}}
		>
			<FontAwesomeIcon icon={["fas", "download"]} />
			<Text color={"black"} marginLeft={"7px"}>
				Export
			</Text>
		</CSVLink>
	) : null;
}
